/* eslint-disable guard-for-in */
import { MobileDatePicker } from '@mui/lab';
import { Box, Grid, TextField, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { IAppointment, IBusiness, IProvider, IService, IUnavailability } from '../../models/api/entities';
import { ITimetable } from '../../models/ITimetable';
import { DATE_FORMAT } from '../../modules/Constant';
import { dateAsTimeToMinute, minuteToMilliseconds } from '../../modules/utils/Utils';
import Timetable from './Timetable';

interface Props {
    business: IBusiness;
    appointments: IAppointment[];
    providers: IProvider[];
    unavailabilities: IUnavailability[];
    setCurDate: (selectedDate: dayjs.Dayjs) => void;
}

const TimetableSection = ({ business, providers, appointments, unavailabilities, setCurDate }: Props) => {
    const [date, setDate] = useState(dayjs().startOf('day'));
    const [timeTable, setTimetable] = useState<ITimetable>({});
    const handleDateChange = useCallback(
        (selectedDate: dayjs.Dayjs | null) => {
            if (selectedDate) {
                setDate(selectedDate);
                setCurDate(selectedDate);
            }
        },
        [setCurDate]
    );

    // Build timetable template
    const buildTimeTable = useCallback(() => {
        const interval = 60; // TODO: Add support for custom timetable interval - e.g. 30 min / 1 day

        const openHour = business.operatingHours.open / interval;
        const closeHour = business.operatingHours.close / interval;

        const tempTimeTable = {};
        for (let currentHour = openHour; currentHour < closeHour; currentHour += 1) {
            tempTimeTable[currentHour * interval] = [];
        }
        return tempTimeTable;
    }, [business.operatingHours.open, business.operatingHours.close]);

    // Add value to timetable template
    useEffect(() => {
        const selectedDateAppointments = appointments.filter((appointment) => dayjs(appointment.startTime).isSame(date, 'day'));

        const tempTimetable = buildTimeTable();
        for (const stringSlotMinute in tempTimetable) {
            const slotMinute = parseInt(stringSlotMinute, 10);
            const slotTime = dayjs.utc(minuteToMilliseconds(slotMinute));

            tempTimetable[slotMinute] = selectedDateAppointments.filter((appointment) => {
                const duration = (appointment.service as unknown as IService).duration;
                const startTime = dateAsTimeToMinute(dayjs(appointment.startTime));
                const endTime = dateAsTimeToMinute(dayjs(appointment.startTime).add(duration, 'minutes')); // TODO: Calculate end time from backend

                return slotTime.isBetween(dayjs(minuteToMilliseconds(startTime)), dayjs(minuteToMilliseconds(endTime)), 'hours', '[)');
            });
        }
        setTimetable(tempTimetable);
    }, [appointments, date, buildTimeTable]);

    return (
        <Grid container spacing={3} direction="column">
            <Grid item>
                <Box sx={{ mx: 'auto', width: 250, pt: 5 }}>
                    <Typography variant="h4">Select Date</Typography>
                    <Typography variant="h4" fontWeight={300}>
                        กรุณาเลือกวันเพื่อดูข้อมูล
                    </Typography>
                </Box>
                <Box sx={{ mx: 'auto', width: 200, pt: 2 }}>
                    <MobileDatePicker
                        value={date}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} />}
                        inputFormat={DATE_FORMAT}
                    />
                </Box>
            </Grid>
            <Grid item>
                <Timetable providers={providers} unavailabilities={unavailabilities} timeTable={timeTable} date={date} />
            </Grid>
        </Grid>
    );
};

export default TimetableSection;
